// Section 9: Shelter (basic). 6 build points, 8 wood; 4 beds; warmth need 1.0x (no modifier).
// Completing a queued shelter is a promised build (Section 16): production marks the
// `building-complete` entry `promised` (config.building.promisedBuildTypes) and the society
// phase applies trust +3. Constants: config.buildings.shelter.
import type { Config } from '../../config';
import { buildingEffectHook, noDeltas } from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';

export function shelter(config: Config) {
  const c = config.buildings.shelter;

  return defineBuilding({
    id: 'shelter',
    label: 'Shelter',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { wood: c.wood },
    material: 'wood',
    beds: c.beds,
    plots: 0,
    capacity: {},
    limit: { kind: 'none' },
    modifierTargets: ['buildingEffect'],
    modifiers: buildingEffectHook('shelter'),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
